import { GrayColors } from "@smartsuite/types";
import styled from "styled-components";

export const Wrapper = styled.div`
  .weekday-text {
    .medium {
      font-weight: 400;
    }
  }
`;

export const Pipe = styled.div`
  border-left: 1px solid ${GrayColors["G-1-5"]};
  height: 36px;
  margin-left: 20px;
  margin-right: 20px;
`;
